import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Music, ExternalLink, Share, Radio } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/Assets/logo.png" alt="Jimmy'z Band Logo" className="logo-img" />
            </Link>
            <p className="footer-tagline">
              A versatile live music band hailing from Pinkcity Jaipur, spreading melodies across the world with energetic performances.
            </p>
            <div className="footer-socials">
              <a href="https://www.youtube.com/watch?v=jwjZGmhwgLA" target="_blank" rel="noreferrer" aria-label="YouTube"><ExternalLink size={18} /></a>
              <a href="#" aria-label="Facebook"><Radio size={18} /></a>
              <a href="#" aria-label="Instagram"><Share size={18} /></a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <div className="footer-divider" />
            <ul>
              {[['/', 'Home'], ['/about', 'About Us'], ['/events', 'Events & Parties'], ['/gallery', 'Gallery'], ['/contact', 'Contact Us']].map(([to, label]) => (
                <li key={to}><Link to={to}>{label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>We Perform</h4>
            <div className="footer-divider" />
            <ul>
              {[
                { label: 'Bollywood Hits', id: 'bollywood-hits' },
                { label: 'English Retros', id: 'english-retros' },
                { label: 'Sufi Geet', id: 'sufi-geet' },
                { label: 'Ghazals', id: 'ghazals' },
                { label: 'Indian Classical', id: 'indian-classical' },
                { label: 'Folk Fusion', id: 'folk-fusion' }
              ].map(g => (
                <li key={g.id}><Link to={`/genre/${g.id}`}><span>♪</span> {g.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact Info</h4>
            <div className="footer-divider" />
            <div className="footer-contacts">
              <div className="contact-item">
                <MapPin size={16} />
                <span>C-218 Hari Marg, Malviya Nagar, Jaipur</span>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <div>
                  <a href="tel:+919414203966">+91 9414203966</a>
                  <a href="tel:+918209227045">+91 8209227045</a>
                </div>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <a href="mailto:info@jimmyzband.com">info@jimmyzband.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© 2021–2025 Jimmy'z Band. All Rights Reserved.</p>
          <div className="awards-strip">
            <span>🏆 Best Versatile Band 2021</span>
            <span>⭐ 4.8/5 Rating</span>
            <span>✓ Google Certified</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
